<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12">
        <v-card dark outlined>
          <v-card-title class="secondary py-1 text-subtitle-1">
            <v-icon left dense> mdi-home </v-icon>
            Categories
          </v-card-title>
          <v-card-text class="pa-0">
            <v-data-table
              :headers="tableHeaders"
              :items="productCategories"
              v-model="selectedCategories"
              :show-select="canManageCategories"
              item-key="CategoryId"
              class="elevation-5"
            >
              <template v-slot:item.CategoryName="{ item }">
                {{
                  item.CategoryName ? item.CategoryName : "No data available"
                }}
              </template>

              <template v-slot:top>
                <v-toolbar flat>
                  <v-row>
                    <v-col cols="2">
                      <v-autocomplete
                        :items="currentStallHolders"
                        v-model="selectedStallHolder"
                        item-text="StallholderName"
                        return-object
                        filled
                        dense
                        outlined
                        hide-details
                        label="Stallholders"
                        @change="handleChangeSH"
                      >
                        <template v-slot:no-data>
                          <v-list-item>
                            <v-list-item-title>
                              <v-icon small color="red lighten-1">
                                mdi-information
                              </v-icon>
                              No event found
                            </v-list-item-title>
                          </v-list-item>
                        </template>
                      </v-autocomplete>
                    </v-col>
                  </v-row>
                  <!-- Copy temporarily disabled
                  <v-btn
                    v-if="canManageCategories"
                    x-small
                    dark
                    class="mb-2 mr-2"
                    :disabled="
                      !selectedStallHolder || selectedCategories.length === 0
                    "
                    @click="copyDialog = true"
                  >
                    <v-icon left x-small> mdi-content-copy </v-icon>
                    Copy to…
                  </v-btn>
                  -->
                  <v-dialog v-model="dialog" max-width="800px" dark>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        v-if="canManageCategories"
                        x-small
                        dark
                        class="mb-2"
                        v-bind="attrs"
                        v-on="on"
                        :disabled="!selectedStallHolder"
                      >
                        <v-icon left x-small> mdi-plus </v-icon>
                        Add Categories
                      </v-btn>
                    </template>
                    <v-card>
                      <v-card-title class="text-h6">
                        {{ formTitle }}
                      </v-card-title>
                      <v-divider></v-divider>

                      <v-card-text>
                        <v-container>
                          <v-form ref="form" v-model="valid" lazy-validation>
                            <v-row>
                              <v-col cols="6">
                                <label
                                  ><B>Event :-</B>
                                  {{
                                    selectedEvent.EventName
                                      ? selectedEvent.EventName
                                      : "N/A"
                                  }}</label
                                >
                              </v-col>
                              <v-col cols="6">
                                <label
                                  ><B>Stallholders :-</B>
                                  {{
                                    selectedStallHolder.StallholderName
                                      ? selectedStallHolder.StallholderName
                                      : "N/A"
                                  }}</label
                                >
                              </v-col>
                            </v-row>

                            <v-text-field
                              v-model="editedItem.CategoryName"
                              label="Category Name"
                              :rules="[
                                (v) => !!v || 'Category Name is required',
                              ]"
                            ></v-text-field>
                          </v-form>
                        </v-container>
                      </v-card-text>

                      <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="blue darken-1" text @click="close">
                          Cancel
                        </v-btn>
                        <v-btn color="blue darken-1" text @click="save">
                          Save
                        </v-btn>
                      </v-card-actions>
                    </v-card>
                  </v-dialog>
                  <v-dialog dark v-model="dialogDelete" max-width="500px">
                    <v-card>
                      <v-card-title class="text-h5"
                        >Are you sure you want to delete Category
                        ?</v-card-title
                      >
                      <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="blue darken-1" text @click="closeDelete"
                          >Cancel</v-btn
                        >
                        <v-btn
                          color="blue darken-1"
                          text
                          @click="deleteItemConfirm"
                          >OK</v-btn
                        >
                        <v-spacer></v-spacer>
                      </v-card-actions>
                    </v-card>
                  </v-dialog>
                </v-toolbar>
              </template>
              <template v-slot:item.actions="{ item }">
                <template v-if="canManageCategories">
                  <v-icon small class="mr-2" @click="editItem(item)">
                    mdi-pencil
                  </v-icon>
                  <v-icon small @click="deleteItem(item)"> mdi-delete </v-icon>
                </template>
              </template>
              <template v-slot:no-data>
                <v-btn color="primary"> No categories for this event </v-btn>
              </template>
            </v-data-table>

            <CopyToStallholderDialog
              ref="copyDialog"
              v-model="copyDialog"
              :source-event-id="(selectedEvent && selectedEvent.EventId) || ''"
              :source-stallholder-id="
                (selectedStallHolder && selectedStallHolder.StallholderId) || ''
              "
              :category-ids="selectedCategoryIds"
              :product-ids="[]"
              @copy="handleCopyTo"
            />
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import "izitoast/dist/css/iziToast.min.css"; // loading css
import iziToast from "izitoast/dist/js/iziToast.min.js"; // you have access to iziToast now
import { mapState, mapActions, mapMutations } from "vuex";
import CopyToStallholderDialog from "@/components/productManagement/CopyToStallholderDialog.vue";
import { hasReadOrWrite, hasWrite } from "@/utils/permissions";

export default {
  components: {
    CopyToStallholderDialog,
  },
  props: {
    productsData: {
      type: Object,
      default: () => ({
        productCategories: [],
      }),
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    dialog: false,
    dialogDelete: false,
    copyDialog: false,
    selectedCategories: [],

    editedIndex: -1,
    editedItem: {
      EventId: "",
      StallholderId: "",
      CategoryName: "",
    },
    defaultItem: {
      EventId: "",
      StallholderId: "",
      CategoryName: "",
    },
    valid: true,
  }),

  computed: {
    ...mapState("filter", ["globalEventFilter", "IsAdmin"]),
    ...mapState("admin", ["currentStallHolders", "currentStallholder"]),

    eventPermission() {
      return this.globalEventFilter?.Permission || "None";
    },

    stallholderPermission() {
      return this.currentStallholder?.Permission || "None";
    },

    // Event Read, or Read/Write on the current stallholder (or any SH on this event)
    canViewCategories() {
      if (this.IsAdmin || hasReadOrWrite(this.eventPermission)) {
        return true;
      }
      if (hasReadOrWrite(this.stallholderPermission)) {
        return true;
      }
      return (this.currentStallHolders || []).some((sh) =>
        hasReadOrWrite(sh.Permission)
      );
    },

    // Event Write, stallholder Write, or TSG admin
    canManageCategories() {
      return (
        this.IsAdmin ||
        hasWrite(this.eventPermission) ||
        hasWrite(this.stallholderPermission)
      );
    },

    tableHeaders() {
      const headers = [{ text: "Category Name", value: "CategoryName" }];
      if (this.canManageCategories) {
        headers.push({ text: "Actions", value: "actions", sortable: false });
      }
      return headers;
    },

    productCategories() {
      if (!this.canViewCategories) return [];
      return this.productsData.productCategories || [];
    },

    selectedCategoryIds() {
      return (this.selectedCategories || [])
        .map((c) => c.CategoryId)
        .filter(Boolean);
    },

    selectedStallHolder: {
      get() {
        return this.currentStallholder;
      },
      set(value) {
        this.setCurrentStallholder(value);
      },
    },

    formTitle() {
      return this.editedIndex === -1 ? "New Category" : "Edit Category";
    },

    selectedEvent: {
      get() {
        return this.globalEventFilter;
      },
      set(value) {
        console.log("EVENT IS CHANGED, MAKE API REQUEST", value);
      },
    },
  },
  watch: {
    dialog(val) {
      val || this.close();
    },
    dialogDelete(val) {
      val || this.closeDelete();
    },
  },
  methods: {
    ...mapActions("admin", ["createCategories", "copyProductsBatch"]),
    ...mapMutations("admin", ["setCurrentStallholder"]),

    handleChangeSH: function (obj) {
      if (obj) {
        this.setCurrentStallholder(obj);
        this.selectedCategories = [];
        // Note: Data will be refreshed by parent component
      }
    },

    async handleCopyTo(payload, destination) {
      try {
        const response = await this.copyProductsBatch(payload);
        const copiedCategories = response?.CopiedCategories ?? 0;
        iziToast.success({
          title: "Copied",
          message: `Copied ${copiedCategories} categor${
            copiedCategories === 1 ? "y" : "ies"
          } to ${destination.stallholder.StallholderName} (${
            destination.event.EventName
          }). Switch to that stallholder to view them.`,
          position: "topRight",
        });
        this.selectedCategories = [];
        this.copyDialog = false;
        this.$emit("refresh-data");
      } catch (err) {
        console.error("Copy categories failed:", err);
        const message =
          err?.response?.data?.message ||
          err?.message ||
          "Copy failed. Please try again.";
        if (this.$refs.copyDialog) {
          this.$refs.copyDialog.setError(message);
        }
        iziToast.warning({
          title: "Copy failed",
          message,
          position: "topRight",
        });
      }
    },

    editItem(item) {
      if (!this.canManageCategories) return;
      this.editedIndex = this.productCategories.indexOf(item);

      this.editedItem.EventId = item.EventId;
      this.editedItem.StallholderId = item.StallholderId;
      this.editedItem.CategoryId = item.CategoryId;
      this.editedItem.CategoryName = item.CategoryName;

      let selected = this.currentStallHolders.filter((element) => {
        return element.StallholderId === item.StallholderId;
      });

      if (selected.length > 0) {
        this.setCurrentStallholder(selected[0]);
      }

      this.dialog = true;
    },

    deleteItem(item) {
      if (!this.canManageCategories) return;
      this.editedIndex = this.productCategories.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialogDelete = true;
    },

    deleteItemConfirm() {
      try {
        if (this.editedItem.StallholderId) {
          let event_item = [
            {
              Type: "product_categories",
              Action: "delete",
              Properties: this.editedItem,
            },
          ];

          let submitEvent = {
            event_items: event_item,
          };
          this.createCategories(submitEvent)
            .then((response) => {
              console.log(
                "deleteItemConfirm () createCategories response: ",
                response
              );

              iziToast.success({
                title: "Category",
                message: "Successfully delete record!",
                position: "topRight",
              });

              this.$emit("refresh-data");
            })
            .catch((err) => {
              console.log("ERROR: ", err);

              iziToast.warning({
                title: "Category",
                message: "Fail to delete record!",
                position: "topRight",
              });
            });
        }
      } catch (e) {
        console.log("ERROR: ", e);
      }

      this.closeDelete();
    },

    close() {
      this.dialog = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },

    closeDelete() {
      this.dialogDelete = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },

    async save() {
      if (!this.$refs.form || !this.$refs.form.validate()) {
        return;
      }

      const stallholderId = this.selectedStallHolder?.StallholderId;
      const eventId = this.selectedEvent?.EventId;
      if (!eventId || !stallholderId) {
        iziToast.warning({
          title: "Category",
          message: "Select an event and stallholder before saving.",
          position: "topRight",
        });
        return;
      }

      this.editedItem.EventId = eventId;
      this.editedItem.StallholderId = stallholderId;

      const submitEvent = {
        event_items: [
          {
            Type: "product_categories",
            Action: this.editedIndex === -1 ? "Create" : "Edit",
            Properties: { ...this.editedItem },
          },
        ],
      };

      try {
        await this.createCategories(submitEvent);
        iziToast.success({
          title: "Category",
          message: "Successfully saved category.",
          position: "topRight",
        });
        this.close();
        this.$emit("refresh-data");
        // GSI on StallholderId can lag immediately after put_item
        setTimeout(() => this.$emit("refresh-data"), 800);
      } catch (err) {
        console.error("save() createCategories error:", err);
        const status = err?.response?.status;
        const message =
          status === 403
            ? "You do not have permission to create categories on this event (needs event/stallholder Write or TSG admin)."
            : err?.response?.data?.message ||
              err?.message ||
              "Failed to save category.";
        iziToast.warning({
          title: "Category",
          message,
          position: "topRight",
        });
      }
    },
  },
};
</script>
<style scoped>
h1 {
  color: #a09c94;
  font-family: sans-serif;
}
</style>
